import { allFilesUploadStartAction, allRCFilesUploadStartAction } from '../../actions';
import { FileService } from '../../services';
import { EnvironmentService } from "../../../common";
export const getOnFilesSelected = (dispatch, fileInputProps) => {
    const onFilesReady = (uploadFilesActionPayload) => {
        dispatch(allFilesUploadStartAction(uploadFilesActionPayload));
    };
    return (fileList) => {
        const jpegImageFileExtensionRenameFlag = getJpegImageFileExtensionRenameFlag();
        FileService.uploadFiles(Object.assign(Object.assign({}, fileInputProps), { fileList,
            onFilesReady, isPdfTaggingEnabled: fileInputProps.isPdfToImageTaggingEnabled, isJPEGImageExtensionRenameEnabled: jpegImageFileExtensionRenameFlag }));
    };
};
export const getOnRCFilesSelected = (dispatch, fileInputProps) => {
    const onFilesReady = (uploadFilesActionPayload) => {
        dispatch(allRCFilesUploadStartAction(uploadFilesActionPayload));
    };
    return (fileList) => {
        FileService.uploadFiles(Object.assign(Object.assign({}, fileInputProps), { fileList,
            onFilesReady }));
    };
};
export const getJpegImageFileExtensionRenameFlag = () => EnvironmentService.getEnvironment().isJPEGImageExtensionRenameEnabled;
//# sourceMappingURL=fileInputContainerHelper.js.map